import React from "react";
import { createMedia } from "@artsy/fresnel";

// -- Semantic based breakpoints

export const breakpoints = {
  all: 0,
  mobile: 320,
  smallTablet: 520, // custom for Sherpa
  tablet: 768,
  computer: 992,
  largeScreen: 1200,
  widescreen: 1920
};

const AppMedia = createMedia({ breakpoints });

export const mediaStyles = AppMedia.createMediaStyle();

export const { Media, MediaContextProvider } = AppMedia;

// -- MediaAs to replace SherpaResponsive functionality

const mediaPropConstraints = [
  "at",
  "lessThan",
  "greaterThan",
  "greaterThanOrEqual",
  "between",
  "interaction"
];

export function MediaAs(props) {
  const ElementType = props.as ? props.as : "div";

  const splitProps = Object.keys(props).reduce(
    (acc, prop) => {
      if (prop === "as") return acc;
      if (mediaPropConstraints.indexOf(prop) === -1) {
        acc.as[prop] = props[prop];
      } else {
        acc.media[prop] = props[prop];
      }
      return acc;
    },
    { as: {}, media: {} }
  );

  return (
    <AppMedia.Media {...splitProps.media}>
      {(mediaClassNames, renderChildren) => {
        if (renderChildren) {
          return <ElementType {...splitProps.as} className={mediaClassNames} />;
        }
        return null;
      }}
    </AppMedia.Media>
  );
}
